import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../API/api';

// Fetch User Data
export const fetchUser = createAsyncThunk('user/fetchUser', async (_, { rejectWithValue }) => {
  try {
    const response = await api.get('/user/me');
    console.log("User Data:", response.data);
    return response.data; // يتوقع { id, username, email, role, profile_image }
  } catch (error) {
    console.log('Something went wrong while fetching user');
    return rejectWithValue(error.response?.data?.message || 'Error fetching user');
  }
});

const userSlice = createSlice({
  name: 'user',
  initialState: {
    data: null, // تخزين كائن المستخدم الكامل
    loading: false,
    error: null,
  },
  reducers: {
    logout: (state) => {
      state.data = null;
      state.error = null;
      localStorage.removeItem('token');
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchUser.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { logout } = userSlice.actions;
export default userSlice.reducer;